import baseApi from "./RootBaseApi";
import {
  NotificationTemplateListApiResponse,
  NotificationTemplateListQueryParams,
  NotificationTemplateSingleApiResponse,
  UpdateNotificationTemplatePayload,
} from "@/types/notification-template-management.types";

export const NotificationTemplateService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationTemplates: builder.query<
      NotificationTemplateListApiResponse,
      NotificationTemplateListQueryParams
    >({
      query: ({ page, limit, search } = {}) => ({
        url: "notification-templates",
        method: "GET",
        params: {
          page,
          limit,
          ...(search ? { search } : {}),
        },
        // Default language header; can be overridden by baseQuery if needed
        headers: { "x-lang": "en" },
      }),
      providesTags: ["NotificationTemplates"],
      keepUnusedDataFor: 0,
    }),

    getNotificationTemplateById: builder.query<
      NotificationTemplateSingleApiResponse,
      { id: string; lang?: "en" | "fi" | "de" | "sv" }
    >({
      query: ({ id, lang = "en" }) => ({
        url: `notification-templates/${id}`,
        method: "GET",
        headers: { "x-lang": lang },
      }),
      providesTags: (result, error, { id }) => [
        { type: "NotificationTemplates" as const, id },
      ],
      keepUnusedDataFor: 0,
    }),

    updateNotificationTemplate: builder.mutation<
      NotificationTemplateSingleApiResponse,
      {
        id: string;
        data: UpdateNotificationTemplatePayload;
        lang: "en" | "fi" | "de" | "sv";
      }
    >({
      query: ({ id, data, lang }) => ({
        url: `notification-templates/${id}`,
        method: "PATCH",
        data,
        headers: { "x-lang": lang },
      }),
      invalidatesTags: (result, error, { id }) => [
        "NotificationTemplates",
        { type: "NotificationTemplates" as const, id },
      ],
    }),
  }),
});

export const {
  useGetNotificationTemplatesQuery,
  useGetNotificationTemplateByIdQuery,
  useUpdateNotificationTemplateMutation,
} = NotificationTemplateService;
